import { render, staticRenderFns } from "./HearingAidList.vue?vue&type=template&id=6024083a&scoped=true&"
import script from "./HearingAidList.vue?vue&type=script&lang=js&"
export * from "./HearingAidList.vue?vue&type=script&lang=js&"
import style0 from "./HearingAidList.vue?vue&type=style&index=0&id=6024083a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6024083a",
  null
  
)

export default component.exports